import { createAsyncThunk } from '@reduxjs/toolkit';
import { postJoinExistingEmployeeToProject } from '../services/postJoinExistingEmployeeToProject.service';

export const joinExistingEmployeeToProject = createAsyncThunk(
  'resources/joinExistingEmployeeToProject',
  async (joinData) => {
    const { projectId, userId, employerBusinessId, recordDate } = joinData;

    const response = await postJoinExistingEmployeeToProject({
      projectId,
      userId,
      employerBusinessId,
      recordDate,
    });
    return response;
  }
);
